import React from "react";
import { CustomIcon, CustomModal } from "../../../../components";
import Context from "../../../../context";
import { ICreateAndUpdateDriver } from "../../../../types/driver.interface";

import Component from "./Component";

import "./index.sass";
import { useTranslation } from "react-i18next";

const Create = ({
  role,
}: {
  role: "ADMIN" | "SUPER_AGENT_SCHOOL" | "COMPANY";
}) => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, createFunction } = React.useContext(
    Context.DriverScreen
  );
  const [step, setStep] = React.useState<number>(1);
  const [formData, setFormData] = React.useState<ICreateAndUpdateDriver>({});

  function submitDriverInformation(event: ICreateAndUpdateDriver) {
    setFormData({ ...formData, ...event });
    setStep(2);
  }

  function onBackCarInformation(event: ICreateAndUpdateDriver) {
    setFormData({ ...formData, ...event });
    setStep(1);
  }

  function submitCarInformation(event: ICreateAndUpdateDriver) {
    createFunction!({ ...formData, ...event });
    setFormData({});
    setStep(1);
  }

  function RenderCreateDriver() {
    switch (step) {
      case 1:
        switch (role) {
          case "ADMIN":
            return (
              <Component.AdministratorDriverInformation
                defaultValues={formData}
                onSubmit={submitDriverInformation}
              />
            );
          case "SUPER_AGENT_SCHOOL":
            return (
              <Component.SuperAgentDriverInformation
                defaultValues={formData}
                onSubmit={submitDriverInformation}
              />
            );
          case "COMPANY":
            return (
              <Component.CompanyDriverInformation
                defaultValues={formData}
                onSubmit={submitDriverInformation}
              />
            );
          default:
            return null;
        }
      case 2:
        return (
          <Component.CarInformation
            defaultValues={formData}
            onSubmit={submitCarInformation}
            onBack={onBackCarInformation}
          />
        );
      default:
        return null;
    }
  }

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="driver-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        hoverTitle={t("createDriver")}
        onClick={() => {
          setShowModal!("CREATE");
        }}
      />
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "CREATE"}
      >
        <RenderCreateDriver />
      </CustomModal>
    </section>
  );
};

export default Create;
